<template minapp="mpx" xlang="wxml">
  <es-layout
    custom-class="page"
    custom-main="custom-main"
    layout="{{['header']}}"
    esMainStyle="{{esMainStyle}}"
    navbarTitle="购票须知"
    navbarStyle="{{navbarStyle}}"
    useDefaultNavbar="{{true}}"
    leftArrow="{{true}}"
  >
    <view class="fixed-nav" slot="header">
      <view class="tab-bar">
        <view wx:for="{{tabs}}" wx:key="index" bindtap="handleTabClick(item.key)">
          <view class="tab-item" wx:class="{{{'active': activeIndex === item.key }}}">
            {{ item.text }}
            <view
              class="item-slider"
              wx:class="{{{'item-slider-active':  activeIndex === item.key }}}"
            >
            </view>
          </view>
        </view>
      </view>
    </view>
    <block wx:for="{{tabs}}" wx:key="index">
      <view wx:if="{{activeIndex === item.key}}" class="content">
        <slot name="{{'tab_' + item.key}}"></slot>
      </view>
    </block>
  </es-layout>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      checkTabIndex: {
        type: String,
        value: 'buy'
      }
    },
    data: {
      tabs: [{
        text: '购票取票',
        key: 'buy'
      },{
        text: '退票',
        key: 'refund'
      },{
        text: '改签',
        key: 'change'
      },{
        text: '候补',
        key: 'scramble'
      },{
        text: '学生票',
        key: 'student'
      },{
        text: '儿童票',
        key: 'child'
      },{
        text: '广深港跨境列车',
        key: 'cross'
      }],
      activeIndex: 'buy',
      esMainStyle: {
        background: 'transparent',
        // paddingTop: '12px'
      },
      navbarStyle: {
        background: '#FFFFFF'
      }
    },
    mounted() {
      this.activeIndex = this.checkTabIndex
    },
    computed: {},
    methods: {
      handleTabClick(k) {
        this.activeIndex = k
      }
    }
  })
</script>

<style scoped lang="stylus">
  .page
    box-sizing border-box
    height 100%
    overflow auto
    background linear-gradient(180deg, rgba(180, 210, 254, 0.8) 0%, rgba(248, 251, 255, 0.8) 81%, rgba(230, 237, 246, 0) 103%), linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 78%, rgba(255, 255, 255, 0) 104%)
  .fixed-nav
    overflow-x scroll
    background-color #fff
    border-top solid 1px rgba(0, 0, 0, 0.08)
  .tab-bar
    background-color #fff
    left 0px
    top 0px
    height 48px
    width 450px
    opacity 1
    /* 自动布局 */
    display flex
    flex-direction row
    align-items center
    padding 12px 0px 0px 0px
    box-sizing border-box
    .tab-item
      margin-left 16px
      /* 自动布局子元素 */
      position static
      flex-shrink 0
      left 96px
      top 0px
      opacity 1
      font-family PingFangSC-Regular
      font-size 16px
      font-weight normal
      line-height 18px
      text-align center
      letter-spacing 0px
      color #000000
      display flex
      flex-direction column
      align-items center
    .item-slider
      width 32px
      height 3px
      border-radius 0.5px
      margin-top 14px
      opacity 1
    .item-slider-active
      background linear-gradient(270deg, #428EFF 0%, #1473FF 99%)
    .active
      color #1473FF
      font-family PingFangSC-Semibold
  .content
    padding 12px 12px 30px
    box-sizing border-box
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'warm-tips': '@/components/warm-tips'
    }
  }
</script>